// Modules
import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

// Styled Components
import * as EVENTSTYLES from './event-content-right-col.styles';

// Types
import { Event } from '../../types/events';
// Assets
import { MarginTop } from '../../styles/common/space.styles';
import { constant } from '../../constants/contant';
import { capitalizedLang } from '../../selectors/common.selector';
import axios from 'axios';
import DrupalMedia from '../drupal-media/drupal-media.component';


const EventContentRightCol = ({ event }: { event: Event }): ReactElement => {
	// Dispatcher
	const dir = useSelector((state: any) => state.common.dir);
	const lang = useSelector((state: any) => capitalizedLang()(state));

	const parser = new DOMParser();
	const htmlDoc = parser.parseFromString(event.body, 'text/html');
	const uuid = htmlDoc.querySelectorAll('drupal-media');
	const getMediaData = async(id: any, el: any) => {
		let url: string = `${constant.URL}${constant.EVENTS_MEDIA}=${id}&include=field_media_image`;
		const {data} = await axios.get(url);
		if (data?.data.length !==0){
			const imageFields = {
				id: id,
				src: data?.included[0].attributes.uri.url,
				alt: data?.data[0].relationships.field_media_image.data.meta.alt,
				type: data?.data[0].type,
			};
			setMedia((prevArray: any) => [...prevArray, imageFields]);
			return;
		} 
		
		url = `${constant.URL}${constant.EVENTS_MEDIA_VIDEO}=${id}`;
		await axios.get(url).then((res)=> {
			const videoData = res.data;
			const videoSrc = videoData?.data[0].attributes.field_media_oembed_video.includes('/watch?v=') ? videoData?.data[0].attributes.field_media_oembed_video.replace('/watch?v=', '/embed/') : videoData?.data[0].attributes.field_media_oembed_video.replace('https://youtu.be/', 'https://www.youtube.com/embed/');
			const videoFields = {
				id: id,
				src: videoSrc,
				alt: videoData?.data[0].attributes.name,
				type: videoData?.data[0].type,
			};
			setMedia((prevArray: any) => [...prevArray, videoFields]);
			return;
		});

	  };

	const [media, setMedia] = useState<any>([]);

	const getImagesData = useCallback(()=>{
		if (uuid.length !== 0) {
			uuid.forEach((media:any)=>{
				getMediaData(media.dataset.entityUuid, media);
			});
		}
	}, []);

	useEffect(() => {
		getImagesData();
	}, [getImagesData]);

	useEffect(()=>{
		if (media.length === uuid.length) {
			media.forEach((item: any) => {
				const drupalEl = document.querySelector(`[data-entity-uuid="${item.id}"]`);
				ReactDOM.render(<DrupalMedia src={item.src} alt={item.alt} type={item.type} />, drupalEl);
			});
		}
	})
	
	
	// Render
	return (
		<EVENTSTYLES.Content dir={dir}>
			<EVENTSTYLES.P className="media-wrapp" dangerouslySetInnerHTML={{ __html: event?.body }} />
			<EVENTSTYLES.P>{event.comments}</EVENTSTYLES.P>

			<MarginTop size={16} />
			{event.accessabilityData && (
				<>
					<EVENTSTYLES.PBold>מידע בנושא נגישות</EVENTSTYLES.PBold>
					<EVENTSTYLES.P>{event.accessabilityData}</EVENTSTYLES.P>
				</>
			)}
				<MarginTop size={32} />
			{event.programUrl && (
				<>
					<EVENTSTYLES.PBold>
						{constant[lang].VARIABLES.PROGRAM}
					</EVENTSTYLES.PBold>
					<EVENTSTYLES.Link href={event.programUrl?.url} target='_blank'>{event.programUrl?.label  || event?.title}</EVENTSTYLES.Link>
				</>
			)}
		</EVENTSTYLES.Content>
	);
};

export default EventContentRightCol;
